module.exports = __webpack_public_path__ + "static/media/tsoai.c75425a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/tsoai.png
// module id = 1288
// module chunks = 0